// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media(max-width: 900px){\n  .miniTable{\n    font-size: 70%;\n  }\n}", "",{"version":3,"sources":["webpack://./src/pages/WorkOrders/index.css"],"names":[],"mappings":"AAAA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":["@media(max-width: 900px){\n  .miniTable{\n    font-size: 70%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
